import axios from 'axios';

const state= {
    Items:{
        data:[],
        total:0,
        filter: null
    },
    OrderJobList:{
        data:[],
        total:0,
    },
    Loadings:{
        list:true,
        general:false
    },
    contractId: 0,
};

const getters = {
    Items : (state) => state.Items,
    OrderJobList : (state) => state.OrderJobList,
    Loadings : (state) => state.Loadings,
    contractId : (state) => state.contractId,
};

const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"list",val:true});
            global.axios.get(`api/contracts/${params.id}/runsheet`, {params:params.data})
                .then(response => {
                    response.data.data.filter = params.data.filter
                    commit( 'setLoadings', {key:"list",val:false});
                    commit( 'setItems', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async generalItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            let contract_id = params.contract_id;
            let maintenance_id = params.maintenance_id;

            commit( 'setLoadings', {key:"general",val:true});
            global.axios.post(`/api/contracts/${contract_id}/maintenance/${maintenance_id}/runsheet`)
                .then(response => {
                    commit( 'setLoadings', {key:"general",val:false});
                    //Reset Item
                    commit( 'setItems', {data:[],total:0,filter: null});
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async assignRunsheetSupplier({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/runsheet/assign`, {
                method: "PUT",
                data:  {
                    runsheet_ids: JSON.stringify(params.ids || []),
                    supplier_id: params.supplier.id,
                    supplier: params.supplier.name
                },
                headers: {
                  Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response)
            })
            .catch(error => reject( error ))
        });
    },
    async searchSupplier({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/users-search`, {
                method: "GET",
                params:  {
                    filter: params,
                    limit: 1000
                },
                headers: {
                  Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response)
            })
            .catch(error => reject( error ))
        });
    },
    getJoblist({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"list",val:true});
            global.axios.get(`api/runsheet`, {params:params})
                .then(response => {
                    commit( 'setLoadings', {key:"list",val:false});
                    commit( 'setOrderJobList', response.data.data);
                    resolve( response.data.data );
                })
                .catch(error => reject( error.response.data ));
        });
    },
    async getJobQRCodes({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/runsheet/qr-code`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async updateJobQRCodes({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/runsheet/qr-code/${params.id}`, params.data)
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async downloadJobQRCode({commit}, id){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/runsheet/qr-code/${id}/download`)
                .then(response => {
                    resolve( response.data );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.Items.data = data.items;
        state.Items.total = data.total;
        state.Items.filter = data.filter;
    },
    setOrderJobList (state,data) {
        state.OrderJobList.data = data.items;
        state.OrderJobList.total = data.total;
    },
    setLoadings (state,data) {
        if(data.key === "list"){
            state.Loadings.list = data.val;
        }
        if(data.key === "general"){
            state.Loadings.general = data.val;
        }
    },
    setcontractId(state,val){
        state.contractId = val;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}